// When changing these values, also change the values in breakpoints.settings.scss

export const DEFAULT_BREAKPOINT_SMALL = {
    alias: 'sm',
    mediaQuery: 'screen and (min-width: 0px) and (max-width: 599px)',
    priority: 1000,
    min: 0,
    max: 599
};

export const DEFAULT_BREAKPOINT_MEDIUM = {
    alias: 'md',
    mediaQuery: 'screen and (min-width: 600px) and (max-width: 899px)',
    priority: 800,
    min: 600,
    max: 899
};

export const DEFAULT_BREAKPOINT_LARGE = {
    alias: 'lg',
    mediaQuery: 'screen and (min-width: 900px) and (max-width: 1199px)',
    priority: 700,
    min: 900,
    max: 1199
};

export const DEFAULT_BREAKPOINT_EXTRA_LARGE = {
    alias: 'xl',
    mediaQuery: 'screen and (min-width: 1200px) and (max-width: 5000px)',
    priority: 600,
    min: 1200,
    max: 5000
};

export const DEFAULT_BREAKPOINT_LT_MEDIUM = {
    alias: 'lt-md',
    overlapping: true,
    mediaQuery: 'screen and (max-width: 599px)',
    priority: 850,
    min: 0,
    max: 599
};

export const DEFAULT_BREAKPOINT_LT_LARGE = {
    alias: 'lt-lg',
    overlapping: true,
    mediaQuery: 'screen and (max-width: 899px)',
    priority: 750,
    min: 0,
    max: 899
};

export const DEFAULT_BREAKPOINT_LT_EXTRA_LARGE = {
    alias: 'lt-xl',
    overlapping: true,
    priority: 650,
    mediaQuery: 'screen and (max-width: 1199px)',
    min: 0,
    max: 1199
};

export const DEFAULT_BREAKPOINT_GT_SMALL = {
    alias: 'gt-sm',
    overlapping: true,
    mediaQuery: 'screen and (min-width: 600px)',
    priority: -950,
    min: 600,
    max: 5000
};

export const DEFAULT_BREAKPOINT_GT_MEDIUM = {
    alias: 'gt-md',
    overlapping: true,
    mediaQuery: 'screen and (min-width: 900px)',
    priority: -850,
    min: 900,
    max: 5000
};

export const DEFAULT_BREAKPOINT_GT_LARGE = {
    alias: 'gt-lg',
    overlapping: true,
    mediaQuery: 'screen and (min-width: 1200px)',
    priority: -750,
    min: 1200,
    max: 5000
};

export const DEFAULT_BREAKPOINTS = [
    DEFAULT_BREAKPOINT_SMALL,
    DEFAULT_BREAKPOINT_MEDIUM,
    DEFAULT_BREAKPOINT_LARGE,
    DEFAULT_BREAKPOINT_EXTRA_LARGE,
    DEFAULT_BREAKPOINT_LT_MEDIUM,
    DEFAULT_BREAKPOINT_LT_LARGE,
    DEFAULT_BREAKPOINT_LT_EXTRA_LARGE,
    DEFAULT_BREAKPOINT_GT_SMALL,
    DEFAULT_BREAKPOINT_GT_MEDIUM,
    DEFAULT_BREAKPOINT_GT_LARGE
];
